import dataUntyped from './data.json';
import { THomeData } from './types';

const data = dataUntyped as THomeData;

export default data;
